export const iconFontAwesomeHumanitarianPeopleRoof = (
	<i className="fa-solid fa-people-roof"></i>
);
